import { render } from "./Loading.vue?vue&type=template&id=d56a9cf0&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=d56a9cf0&lang=css"
import "./Loading.vue?vue&type=style&index=1&id=d56a9cf0&scoped=true&lang=css"

import exportComponent from "D:\\Working\\Projects\\EcosystemPlus\\src\\Web\\Ecosystem.EInvoice.Web\\Themes\\EInvoice\\Mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56a9cf0"]])

export default __exports__